var storage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value))
    },
    get(key) {
        return JSON.parse(localStorage.getItem(key))
    },
    remove(key) {
        localStorage.removeItem(key)
    },
    removeAll()
    {
        localStorage.removeAll()
    }
}




export default storage


// WEBPACK FOOTER //
// ./src/common/localstorage/storage.js